import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';
import { Customer, CustomerAccount } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromStrategy from '@strategy/reducers';

import { MAXIMUM_3A_CONTRIBUTION } from '@app/app.constants';
import { CustomerInvestmentData } from '@shared/models/Strategy';

@Component({
  selector: 'app-strategy-3a-portfolio-summary',
  templateUrl: './strategy-3a-portfolio-summary.component.html',
  styleUrls: ['./strategy-3a-portfolio-summary.component.scss'],
  standalone: false
})
export class Strategy3APortfolioSummaryComponent implements OnInit, OnDestroy, OnChanges {
  protected readonly onDestroy$ = new Subject<void>();
  @Input() customer: Customer;
  @Input() currentAccount: CustomerAccount;

  investmentData: CustomerInvestmentData;

  MAXIMUM_3A_CONTRIBUTION = MAXIMUM_3A_CONTRIBUTION;
  MINIMUM_INVESTMENT: number;
  depositType = '';

  constructor(
    private store: Store,
    private amplitudeService: AmplitudeService
  ) {
    this.store.pipe(select(fromStrategy.selectCustomerInvestmentData), takeUntil(this.onDestroy$)).subscribe((customerInvestmentData) => {
      this.investmentData = customerInvestmentData;
    });
  }

  ngOnInit(): void {
    this.MINIMUM_INVESTMENT = this.currentAccount.minimum_investment;
  }

  trackTooltip(name: string) {
    this.amplitudeService.trackEvent('Tooltip Info Consulted', {
      tooltip_name: name,
      screen: '3a portfolio summary',
      consultation_method: 'hover'
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.currentAccount && (changes.currentAccount.currentValue as CustomerAccount).step_status >= 3) {
      this.depositType = this.currentAccount.max_contribution_level;
      this.MINIMUM_INVESTMENT = this.currentAccount.minimum_investment;
    }
  }

  getStockBondValue(type: 'stock' | 'bond'): number {
    const stock_split = this.currentAccount.step_status === 5 ? this.investmentData.live_stock_split : this.investmentData.stock_split;
    return (type === 'stock' ? stock_split : 1 - stock_split) * 100;
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
